import type { AxiosError } from 'axios';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { RatingWithProductInfo } from '../../server/controllers/rating';
import { getRating } from '../../services/ratings';
import type { TFilters } from '../../types/filters';
import type { OrganizationRatingItem } from '../../types/rating';

export type IState = {
  list: OrganizationRatingItem[];
  loading: boolean;
  loadingError: Partial<AxiosError>;
};

export const fetchRatingsWithProductInfo = createAsyncThunk<RatingWithProductInfo, TFilters>(
  `ratings/fetchRatingsWitProductInfo`,
  async (params) => getRating(params),
);

const ratingsReducer = createSlice({
  name: 'ratings',
  initialState: {
    list: null,
    loading: false,
    loadingError: null,
  },
  reducers: {
    setRating: (state, { payload }: PayloadAction<OrganizationRatingItem[]>) => {
      state.list = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRatingsWithProductInfo.fulfilled, (state, { payload }) => {
      state.list = payload.rating;
      state.loading = false;
      state.loadingError = false;
    });
    builder.addCase(fetchRatingsWithProductInfo.rejected, (state, { payload }) => {
      state.loading = false;
      state.loadingError = payload;
    });
    builder.addCase(fetchRatingsWithProductInfo.pending, (state) => {
      state.list = null;
      state.loading = true;
      state.loadingError = null;
    });
  },
});

const { actions, reducer } = ratingsReducer;
export const { setRating } = actions;
export default reducer;
